













































import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import AbortButton from "@/components/Button/AbortButton.vue";
import SaveButton from "@/components/Button/SaveButton.vue";
import FscModal from "@/components/Modal/FscModal.vue";
import { IBasicNamedDTO } from "@/interfaces/IBasicNamedDTO";
import { ILicenseClassGroup } from "@/interfaces/ILicenseClassGroup";

const DrivingLessonTaskGroupModule = namespace("driving-lesson-task-group");

@Component({
  components: {
    FscModal,
    AbortButton,
    SaveButton,
  },
})
export default class DrivingLessonTaskGroupCreateModal extends Vue {
  public name = "DrivingLessonTaskGroupCreateModal";

  @Prop({ type: Array, default: () => [] })
  public licenseClassGroups!: Array<ILicenseClassGroup>;

  @DrivingLessonTaskGroupModule.Action("create")
  public createGroup: any;

  @DrivingLessonTaskGroupModule.Getter("getIsLoading")
  public loading: any;

  public form: { name: string; licenseClassIds: Array<number> } = { name: "", licenseClassIds: [] };

  public licenseClassRequired = false;

  public toOptions(licenseClasses: Array<IBasicNamedDTO>): Array<{ text: string; value: number }> {
    return licenseClasses.map((licenseClass) => ({ text: licenseClass.name as string, value: licenseClass.id as number }));
  }

  public onAbort(): void {
    this.$bvModal.hide("driving-lesson-task-group-create-modal");
    this.resetForm();
  }

  public async onSubmit(): Promise<void> {
    if (this.form.licenseClassIds.length === 0) {
      this.licenseClassRequired = true;
      return;
    }
    this.licenseClassRequired = false;

    const data = {
      name: this.form.name ? this.form.name.trim() : null,
      licenseClasses: this.form.licenseClassIds.map((id: number): IBasicNamedDTO => ({ id })),
      tasks: [],
    };

    await this.createGroup({ data, resource: "driving-lesson-task-groups" });

    this.$bvModal.hide("driving-lesson-task-group-create-modal");
    this.resetForm();
    this.$emit("created");
  }

  private resetForm(): void {
    this.form = { name: "", licenseClassIds: [] };
    this.licenseClassRequired = false;
  }
}
